import { tg } from '../App'

export const getKey = (key: string) => {
  return `${tg?.initDataUnsafe?.user?.id ?? 'default'}-${key}`
}
